<div id="publicweb" *ngIf="showLinkToPublicWeb" class="no-print">
  <bom-link
    linkName="publicweb-link"
    [url]="publicwebContextUrl"
    target="_self"
    cssClass="button white"
    class="rotate90 blue-link"
    text="{{ 'Link.ToPublicWeb' | tekstresource }}"
    [showIcon]="true"
  >
  </bom-link>
</div>
